import React from 'react';
import SlimHero from '../ui/hero/hero-slim';

export default () => {
  const pageTitle = "Contact Us";
  return <>
    <SlimHero title={pageTitle} />
    <div className="row">
      <div className="flex-col">
        <div className="">
          <h2>Enquiries</h2>
            <p>Phone: 1800 954 540</p>
            <p>Email:  info@nrn.org.au</p>
            <p>For IT issues: it-support@nrn.org.au</p>
          <h2>NRNA Australia officials</h2>
            <p>Address: Level 7, 22 William St, Melbourne VIC 3000</p>
            <p>Postal: PO Box 561, Collins St West VIC 8007</p>
        </div>
      </div>
    </div>
  </>
}
